import { useState } from 'react';

import { useTranslation } from '../../../../hooks/useTranslation';
import { useQueryStateContext } from '../../../../contexts';
import { useVisualComponentsContext } from '../../../../contexts/visualComponents';
import { ValidatedSingleStringValueInputProps } from '../types';
import { CastType } from 'modules/queryBuilder/types';

export const SingleTemplateInput = ({
  onChange,
  value,
  isInvalid,
  isOpenByDefault,
  hasWarning,
  dataType,
  field,
  fieldType,
  comparator,
  castType,
}: ValidatedSingleStringValueInputProps) => {
  const { t } = useTranslation();
  const [search, setSearch] = useState('');
  const { ConditionValueSingleNumberInput, ConditionValueSingleStringInput } =
    useVisualComponentsContext();
  const { isReadOnly } = useQueryStateContext();

  const VisualComponent =
    castType === CastType.MERGE_PARAM
      ? ConditionValueSingleStringInput
      : ConditionValueSingleNumberInput;

  return (
    <VisualComponent
      isDisabled={!!isReadOnly}
      hasError={!!isInvalid}
      hasWarning={hasWarning}
      isOpenByDefault={isOpenByDefault}
      onChange={(val) => {
        if (val) onChange(val);
      }}
      value={value}
      dataType={dataType}
      field={field}
      fieldType={fieldType}
      comparator={comparator}
      placeholder={t('v2.conditionBuilder.singleTemplatePlaceholder')}
      search={search}
      setSearch={setSearch}
    />
  );
};
